import { Button } from '@headlessui/react'

type Props = {
  name: string
  onClick: () => void
  selected: boolean
  padding?: 'sm' | 'lg'
}

export const FilterButton = ({ name, onClick, selected, padding = 'lg' }: Props) => {
  const base =
    'focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:cursor-not-allowed aria-disabled:opacity-75 flex-shrink-0 focus-visible:ring-2 focus-visible:ring-primary rounded-lg data-[hover]:ring-1'
  const selectedClasses =
    'text-primary dark:text-primary-dark ring-1 ring-inset ring-current disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent '

  const paddingClasses = padding === 'sm' ? 'px-2 py-[3px]' : 'px-4 py-2'

  return (
    <Button
      className={`text-[#939BA2] ${base} ${selected && selectedClasses} ${paddingClasses}`}
      onClick={onClick}
    >
      {name}
    </Button>
  )
}
